import {Command, CommandConstructor} from "./Command";

export class GroupCommands implements Command {
  constructor(
    private message: string,
    public commands: Command[],
  ) { }

  execute() {
    console.group(this.message)

    for (const command of this.commands) {
      command.execute();
    }

    console.groupEnd()
  }

  hasCommand(command: CommandConstructor) {
    return this.commands.some(_command => _command instanceof command)
  }
}
